import React from 'react';
import useMediaBlobUrl from '../hooks/useMediaBlobUrl';
import type { CanvasFrame } from '../types';

interface Props {
  frame: CanvasFrame;
}

/**
 * Pure inhoud van een frame (eyebrow/titel/subtitel/ref/media/body-regels),
 * los van positionering/rotatie -- geëxtraheerd uit CanvasFrameElement.tsx
 * zodat zowel de speler (CanvasFrameElement, zelf gepositioneerd) als de
 * editor (CanvasFrameEditable, zijn eigen interactieve positionering) 'm
 * kunnen hergebruiken zonder de transform-styling te dupliceren.
 */
export default function CanvasFrameContent({ frame }: Props) {
  const bodyLines = frame.body ? frame.body.split('\n') : [];
  const mediaUrl = useMediaBlobUrl(frame.media_id);

  return (
    <>
      {frame.eyebrow && <div className="canvas-frame__eyebrow">{frame.eyebrow}</div>}
      {frame.title && <div className="canvas-frame__title">{frame.title}</div>}
      {frame.subtitle && <div className="canvas-frame__subtitle">{frame.subtitle}</div>}
      {frame.ref && <div className="canvas-frame__ref">{frame.ref}</div>}
      {mediaUrl && frame.media_type === 'video' && (
        <video src={mediaUrl} controls className="canvas-frame__media" />
      )}
      {mediaUrl && frame.media_type !== 'video' && (
        <img src={mediaUrl} alt="" className="canvas-frame__media" />
      )}
      {bodyLines.map((line, index) => (
        // eslint-disable-next-line react/no-array-index-key -- regels hebben geen eigen identiteit
        <div key={index} className="canvas-frame__body-line">{line}</div>
      ))}
    </>
  );
}
